"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var MockAuthService =
/** @class */
function () {
  function MockAuthService(mockToken, redirectCallback) {
    var _this = this;

    this.mockToken = mockToken;
    this.redirectCallback = redirectCallback;

    this.logout = function () {};

    this.login = function () {
      return Promise.resolve(_this.mockToken);
    };

    this.loginRedirect = function (state) {
      if (_this.redirectCallback) {
        _this.redirectCallback(undefined, _this.mockToken);
      }
    };

    this.loginRedirectImpersonation = function (state, email) {
      if (_this.redirectCallback) {
        _this.redirectCallback(undefined, _this.mockToken);
      }
    };

    this.getToken = function () {
      return Promise.resolve(_this.mockToken);
    };

    this.isAuthenticated = function () {
      return Promise.resolve(true);
    };
  }

  return MockAuthService;
}();

exports.MockAuthService = MockAuthService;